module.exports = __webpack_public_path__ + "static/media/MSLogo.fae26761.png";